import * as React from 'react';
import { useSelector } from 'react-redux';
import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';
import { selectIsAuthenticated } from '../../selectors/user';

export function FavoritesFolderContainer() {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const handleLogin = () => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  };

  return (
    <FavoritesAssignWidgetContainer
      isAuthenticated={isAuthenticated}
      onWaitForLogin={handleLogin}
      disableNotification
    />
  );
}
